import hPageUtils from "../../_Utils/utilsHomePage";

import { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import ConnUrls from "../../Connections/ConnectURL";
import { CurrentPContext, MasterContext, MessagesObjCssContext, MobiOrNotContext } from "../../ContextApi/context";
import SearchComp from "../../DTechComp/Search";
import ScrollingSaver from "../../DTechComp/ScrollingSaver";
import { isFreshPageLoad } from "../../DTechComp/NavigationTracker";
import CatsLnksComp from "../../Master/CatsLnksComp";
import utilsRests from "../../_Utils/utilsRests";
import myFunctions from "../../myFunctions";
import HomePTopSlides from "./HomePTopSlides";
import MainFavs from "./mainFavs";
import MainNowOpen from "./mainNowOpen";
import MainOnlines from "./mainOnlines";
import MainRest from "./mainRests";
import MainTableReservs from "./MainTableReservs";
import SearchButton from "../../DTechComp/SearchButton";
import { Helmet } from "react-helmet";
import { CityContext } from "../../ContextApi/cityContext";
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';
import { byPlaceRank } from '../../DTechComp/placeRelevance';

const HomePage = (props) => {


  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);

  // const [theData] = useState(TheSrc());
  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const { cityId, myCity } = useContext(CityContext);
  // העיר של הלקוח בפועל - הרשימות מסוננות לפיה בשרת (placeRelevance)
  const myCityId = myCity ? myCity._id : "";
  const [mainRests, setMainRests] = useState([]);
  const [mainRestsReady, setMainRestsReady] = useState(false);
  const [homeDataReady, setHomeDataReady] = useState(false);


  const [mainRestCo, setmainRestCo] = useState();
  const [populars, setPopulars] = useState();
  const [section5, setSection5] = useState();
  const [section6, setSection6] = useState();
  const [section7, setSection7] = useState();
  const [section3, setSection3] = useState();

  const [mainRestCo2, setmainRestCo2] = useState();
  const [mainRestCo3, setmainRestCo3] = useState();
  const [mainRestCo4, setmainRestCo4] = useState();


  const [faveRestCo, setFaveRestCo] = useState();
  const [onlineRestCo, setOnlineRestCo] = useState();

  const [onlineTableOrders, setOnlineTableOrders] = useState();

  const [nowOpen, setNowOpen] = useState();
  const [hPTopSlides, setHPTopSlides] = useState();

  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [bgImgPos, setBgImgPos] = useState("");

  const [nowOpenCount, setNowOpenCount] = useState(true);

  const [waitImgItm, setWaitImgItm] = useState({});
  const [googleSchem, setGoogleSchem] = useState();
  const [breadcrumbSchema, setBreadcrumbSchema] = useState();
  const [messagesObjCss, setMessagesObjCss, goSetTheMsgDisp] = useContext(MessagesObjCssContext);

  useEffect(() => {
    goSetTheMsgDisp();
  }, [])

  useEffect(() => {

    if (currentPage != null) {
      creatGoogleSchema()
    }
    if (history.action !== "POP" || isFreshPageLoad()) props.scrollToTop();
    // אין לאפס כאן את ההזמנה — האיפוס מחק גם את מספר ההזמנה שכבר נוצרה
    // בשרת, ולכן לקוח שעבר בדף הבית באמצע התהליך יצר הזמנה כפולה עם מספר
    // חדש. ההגנה מפני סל מעורב נעשית בעמוד העסק וברגע ההוספה לסל.

    //currentPage עדיין של העמוד הקודם, ולכן חישוב ממנו הציג לרגע תמונה זרה (בד"כ של המאסטר).
    //התמונה נקבעת כשנתוני העמוד מגיעים; עד אז נשאר מסך לבן.
    if (master?.imgWaitingActive === false) setWaitImgItm({ active: false });

    props.shoTopStrp(true);
    //setLoading(false) עבר ל-getHompData: אנימציית היציאה מתחילה רק כשהתמונה וההשהיה ידועות

  }, [])

  // עמוד הבית לפי העיר הנבחרת (בלי עיר - הכללי, כמו קודם)
  useEffect(() => {
    setTheMains();
    getHompData();
  }, [cityId, myCityId])

  useEffect(() => {

    if (currentPage) {
      creatGoogleSchema()
      createBreadcrumbSchema()
    }

  }, [currentPage])


  // מבנה זהה לזה שב-next-ssg/pages/index.js, כדי ששתי הגרסאות של דף הבית - זו שגולשים
  // מקבלים וזו שהזחלנים מקבלים - יתארו לגוגל בדיוק את אותה ישות.
  //
  // קודם היה כאן WebPage בודד עם Organization מקונן כ-publisher, בלי url ובלי מזהים.
  // עכשיו graph עם שלוש ישויות מקושרות: Organization עצמאי (האות החזק למותג), WebSite
  // עם SearchAction (מה שמאפשר תיבת חיפוש של האתר בתוצאות גוגל), ו-WebPage שמצביע אליהן.
  const creatGoogleSchema = () => {
    const domain = ConnUrls.siteDomainNam;
    const logoUrl = master.webSiteLogo ? ConnUrls.media(master.webSiteLogo) : "";

    // sameAs מחבר בגוגל בין האתר לפרופילים הרשמיים שלו, וזה מה שמבסס את זיהוי המותג.
    // נערך באדמין תחת מאסטר > פרטי האתר. שדה ריק לא נשלח.
    const socials = [master.siteFacebook, master.siteInstagram, master.siteTiktok]
      .filter(lnk => lnk && lnk.trim() !== "");

    const theSchem = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${domain}/#organization`,
          "name": "אשדוד בתפריט",
          "alternateName": "AshdodMenu",
          "url": domain,
          ...(logoUrl ? { "logo": { "@type": "ImageObject", "url": logoUrl } } : {}),
          ...(socials.length ? { "sameAs": socials } : {})
        },
        {
          "@type": "WebSite",
          "@id": `${domain}/#website`,
          "url": domain,
          "name": "אשדוד בתפריט",
          "publisher": { "@id": `${domain}/#organization` },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": `${domain}/search?txSrch={search_term_string}`
            },
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@type": "WebPage",
          "@id": `${domain}/#webpage`,
          "url": domain,
          "name": currentPage.pageName,
          "description": currentPage.sEOdescription,
          "isPartOf": { "@id": `${domain}/#website` },
          ...(logoUrl ? { "image": logoUrl } : {}),
          ...(currentPage.secondHead
            ? {
              "additionalProperty": {
                "@type": "PropertyValue",
                "name": "About",
                "value": currentPage.secondHead
              }
            }
            : {})
        }
      ]
    };

    setGoogleSchem(JSON.stringify(theSchem))

  }

  const createBreadcrumbSchema = () => {
    const breadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "דף הבית",
          "item": ConnUrls.siteDomainNam
        }
      ]
    };
    setBreadcrumbSchema(JSON.stringify(breadcrumb));
  }



  const setTheMains = async () => {
    let go = await utilsRests.getMainRests(cityId);

    // הסדר (ידני/דיפולט, קבוע/רנדום) כבר נקבע סופית בשרת.
    // כאן רק דוחפים סגורים לסוף, בלי לגעת בסדר הפנימי.
    let readylist = myFunctions.pushClosedToEnd(go, master);
    // מי שלא מגיע לעיר של הלקוח - בסוף (placeRank מהשרת)
    readylist = byPlaceRank(readylist);

    setMainRests(readylist)
    setMainRestsReady(true);
  }

  const getHompData = async () => {

    try {
      let hPage = await hPageUtils.getHomePage(cityId);
      setData(hPage)
    }
    finally {
      setLoading(false);
    }
  }

  const setData = (hPage) => {
    // key - המקטעים נטענים מחדש בהחלפת מקום / עיר (הם טוענים את הרשימה רק בעלייה)
    const k = (hPage._cityId || "all") + "_" + myCityId;
    setCurrentPage({ ...hPage, pageTYp: "" });
    setWaitImgItm(myFunctions.setTheImgWait(hPage, master, mobiOrNot));

    setHPTopSlides(<HomePTopSlides topImages={hPage.topImages} />)

    setFaveRestCo(<MainFavs key={"fav" + k} header={hPage.TheFavRestsHeader || ""} TheList={hPage.TheFavRests} />)

    // setOnlineRestCo(<MainOnlines TheList={hPage.onlineRests} />)

    setOnlineTableOrders(<MainTableReservs key={"tbl" + k} />)

    setNowOpen(<MainNowOpen key={"nop" + k} header={hPage.onlineRestsHeader || ""} noOpenRests={(trFls) => setNowOpenCount(trFls)} />)

    setPopulars(<MainFavs key={"pop" + k} header={hPage.PopularsHeader || ""} TheList={hPage.Populars} />)
    setSection3(<MainFavs key={"s3" + k} header={hPage.section3Header || ""} TheList={hPage.Section3} />)
    setSection5(<MainFavs key={"s5" + k} header={hPage.section5Header || ""} TheList={hPage.Section5} />)
    setSection6(<MainFavs key={"s6" + k} header={hPage.section6Header || ""} TheList={hPage.Section6} />)
    setSection7(<MainFavs key={"s7" + k} header={hPage.section7Header || ""} TheList={hPage.Section7} />)

    setHomeDataReady(true);
  }

  const serachBuis = (txtSearch) => {
    history.push("/search?txSrch=" + txtSearch);
  }

  return (
    <div className="inerPage Hpage">

      <WaitImgOverlay item={waitImgItm} ready={!loading} />
      {/* <div className={loading ? "imgWaiting" : `imgWaiting animate__animated animate__fast animate__zoomOut ${currentPage.imgDelay ? currentPage.imgDelay : master.imgDelay}`}>
        <img src={`${ConnUrls.media(master.waitingImgMaster)}`} />
      </div> */}
      {!(mainRestsReady && homeDataReady) ? "" :
        <div className={"Hpage"}>

          {!mobiOrNot ?
            <div className="headeronDeskTop">
              <div className={"onRight"}>
                <div className={"spaceRightLong"}>
                  <h1 className={"h1margin anakMeod bold MyFont"}>{currentPage.mainHead}</h1>
                </div>
                <div className={"spaceRightLong"}>
                  <h2 className={"regular grayText"}>{currentPage.secondHead}</h2>
                </div>
              </div>
              <div className={"onLeft"}>
                <div className={"srchDskTop"}>
                  <SearchButton pHolder={"חפש שם עסק, מנה או פריט"} />
                </div>
              </div>
            </div> :
            <div className={"mobiTopSpacer"}></div>}

          {hPTopSlides}
          <div className={"detailsDiv"} loading={"lazy"}>
            {mobiOrNot ?
              <div className={"mastSec firstMastSec"}>
                <SearchButton pHolder={"חפש שם עסק, מנה או פריט"} />
              </div>
              : ""}


            {/* <div className={"spaceRightLong MbigFont bold SecondFont"}>
              קטגוריות
            </div> */}
            <div className={mobiOrNot ? "mastSec" : ""}>
              <CatsLnksComp />
            </div>




            <div className={"fullRow overflowHid"}>
              {
                mobiOrNot ?
                  <>
                    <MainRest mainRests={mainRests} fromitem={"0"} toitem={"0"} />
                    <MainRest mainRests={mainRests} fromitem={"1"} toitem={"1"} />
                    <MainRest mainRests={mainRests} fromitem={"2"} toitem={"2"} />
                  </>
                  :
                  <>
                    <MainRest mainRests={mainRests} fromitem={"0"} toitem={"3"} />
                    <MainRest mainRests={mainRests} fromitem={"4"} toitem={"7"} />
                  </>
              }
            </div>

            {nowOpen}


            <div className={"fullRow overflowHid"}>
              {mobiOrNot &&
                <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                  <MainRest mainRests={mainRests} fromitem={"3"} toitem={"3"} />
                  <MainRest mainRests={mainRests} fromitem={"4"} toitem={"4"} />
                  <MainRest mainRests={mainRests} fromitem={"5"} toitem={"5"} />
                </div>
              }
            </div>

            {faveRestCo}



            {mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"6"} toitem={"6"} />
                <MainRest mainRests={mainRests} fromitem={"7"} toitem={"7"} />
                <MainRest mainRests={mainRests} fromitem={"8"} toitem={"8"} />
              </div>
            }


            {section3}



            {mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"9"} toitem={"9"} />
                <MainRest mainRests={mainRests} fromitem={"10"} toitem={"10"} />
                <MainRest mainRests={mainRests} fromitem={"11"} toitem={"11"} />
              </div>
            }


            {populars}


            {mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"12"} toitem={"12"} />
                <MainRest mainRests={mainRests} fromitem={"13"} toitem={"13"} />
                <MainRest mainRests={mainRests} fromitem={"14"} toitem={"14"} />
              </div>}

            {section5}

            {
              mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"15"} toitem={"15"} />
                <MainRest mainRests={mainRests} fromitem={"16"} toitem={"16"} />
                <MainRest mainRests={mainRests} fromitem={"17"} toitem={"17"} />
              </div>
            }

            {section6}

            {
              mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"18"} toitem={"18"} />
                <MainRest mainRests={mainRests} fromitem={"19"} toitem={"19"} />
                <MainRest mainRests={mainRests} fromitem={"20"} toitem={"20"} />
              </div>
            }
            {section7}

            {
              mobiOrNot &&
              <div className={"fullRow overflowHid spaceBLockesUp_Minus-10"}>
                <MainRest mainRests={mainRests} fromitem={"21"} toitem={"21"} />
                <MainRest mainRests={mainRests} fromitem={"22"} toitem={"22"} />
                <MainRest mainRests={mainRests} fromitem={"23"} toitem={"23"} />
              </div>
            }

            <ScrollingSaver pagNam={"HomePage"} contentReady={mainRestsReady} />
          </div>
        </div>
      }

      <Helmet
        meta={[
          {
            property: "og:url", content: `${ConnUrls.siteDomainNam}`
          }
        ]}>

        <link rel="canonical" href={`${ConnUrls.siteDomainNam}`} />
        <script className='structured-data-list' type="application/ld+json">{googleSchem}</script>
        {breadcrumbSchema && <script type="application/ld+json">{breadcrumbSchema}</script>}

      </Helmet>

    </div >
  );
}

export default HomePage;
